import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '@app/shared/components/shared.module';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { QuicklinkModule } from 'ngx-quicklink';
import { ApplicationComponentsModule } from '../application/application.module';
import { ApplicationProgramComponentsModule } from '../application/application.program.module';
import { RouterModule } from '@angular/router';

import { ApplicationChainCardComponent } from './components/application-chain-card/application-chain-card.component';
import { ApplicationChainDocumentListComponent } from './components/application-chain-document-list/application-chain-document-list.component';
import { ApplicationChainEnrolledComponent } from './components/application-chain-enrolled/application-chain-enrolled.component';
import { ApplicationChainItemMobileComponent } from './components/application-chain-item-mobile/application-chain-item-mobile.component';
import { ApplicationChainItemComponent } from './components/application-chain-item/application-chain-item.component';
import { ApplicationChainListComponent } from './components/application-chain-list/application-chain-list.component';
import { ApplicationChainFirstdayChecklistComponent } from './components/application-chain-firstday-checklist/application-chain-firstday-checklist.component';

@NgModule({
    declarations: [
        ApplicationChainItemComponent,
        ApplicationChainListComponent,
        ApplicationChainItemMobileComponent,
        ApplicationChainDocumentListComponent,
        ApplicationChainCardComponent,
        ApplicationChainEnrolledComponent,
        ApplicationChainFirstdayChecklistComponent,
    ],
    imports: [
        QuicklinkModule,
        IonicModule,
        CommonModule,
        FontAwesomeModule,
        PipesComponentsModule,
        SharedComponentsModule,
        ApplicationComponentsModule,
        ApplicationProgramComponentsModule,
        RouterModule,
    ],
    exports: [
        ApplicationChainItemComponent,
        ApplicationChainListComponent,
        ApplicationChainItemMobileComponent,
        ApplicationChainDocumentListComponent,
        ApplicationChainCardComponent,
        ApplicationChainEnrolledComponent,
        ApplicationChainFirstdayChecklistComponent,
    ],
})
export class ApplicationChainComponentsModule {}
